import React from "react";
import { Link, useHistory } from "react-router-dom";
import { RemoveUserAuth } from "../store/actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import axios from "axios";

function UserMenu() {
  const user = useSelector((state) => state.user_auth);
  const [userInfo, setUserInfo] = useState({});
  const [isDisabled, setIsDisabled] = useState(true);
  const [isActive, setActive] = useState(false);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const enableForm = () => {
    setIsDisabled(!isDisabled);
  };

  const showForm = () => {
    setShow(!show);
  };

  const toggleClass = () => {
    setActive(!isActive);
  };

  const updateUserInfo = (e) => {
    setUserInfo({
      ...userInfo,
      [e.target.name]: e.target.value,
    });
  };
  const removeUser = () => {
    dispatch(RemoveUserAuth);
    history.push("/");
  };

  const storeChanges = async () => {
    const url = process.env.REACT_APP_API_URL + `/users/`;
    const response = await axios({
      method: "PATCH",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${user.token}`,
      },
      data: {
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        email: userInfo.email,
        address: userInfo.address,
        phone: userInfo.phone,
      },
    });
    console.log("Respuesta del servidor : ", response);
  };

  useEffect(() => {
    const init = async () => {
      const { data } = await axios({
        method: "GET",
        url: process.env.REACT_APP_API_URL + "/users/" + user.userName,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      });
      /* const { data } = await axios.get(process.env.REACT_APP_API_URL + "/users/" + user.userName); */
      setUserInfo(data);
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <form className={show ? "d-initial" : "d-none"}>
        <label for="inputFirstName" className="fw-bold fs-6 mt-3 mb-2">
          Nombre*
        </label>
        <input
          name="firstName"
          type="text"
          className="form-control"
          id="inputFirstName"
          value={userInfo.firstName}
          disabled={isDisabled}
          onChange={updateUserInfo}
        />
        <label for="inputFirstName" className="fw-bold fs-6 mt-3 mb-2">
          Apellido*
        </label>
        <input
          name="lastName"
          type="text"
          className="form-control"
          id="inputLastName"
          value={userInfo.lastName}
          disabled={isDisabled}
          onChange={updateUserInfo}
        />
        <label for="inputEmail" className="fw-bold fs-6 mt-3 mb-2">
          Dirección de correo electrónico *
        </label>
        <input
          type="email"
          name="email"
          className="form-control"
          id="inputEmail"
          value={userInfo.email}
          disabled={isDisabled}
          onChange={updateUserInfo}
          pattern="[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?"
        />

        <label for="inputaddress" className="fw-bold fs-6 mt-3 mb-2">
          Dirección de entrega (Ej: calle, número de puerta, apto, esquina)*
        </label>
        <input
          name="address"
          type="text"
          className="form-control"
          id="address"
          value={userInfo.address}
          disabled={isDisabled}
          onChange={updateUserInfo}
        />

        <label for="inputphone" className="fw-bold fs-6 mt-3 mb-2">
          Teléfono
        </label>
        <input
          name="phone"
          type="number"
          className="form-control"
          id="inputphone"
          value={userInfo.phone}
          disabled={isDisabled}
          onChange={updateUserInfo}
        />
      </form>

      {show && (
        <li
          id="editProfile"
          className="text-dark d-block w-100 mt-3 pointer underline-decoration"
          onClick={() => {
            toggleClass();
            enableForm();
            if (isActive) {
              storeChanges();
            }
          }}
        >
          {isActive ? "Guardar" : "Editar perfil"}
        </li>
      )}
      <li
        id="editProfile"
        className="text-dark d-block w-100 mt-3 pointer underline-decoration"
        onClick={() => {
          showForm();
        }}
      >
        {show ? "Ocultar datos personales" : "Ver datos personales"}
      </li>
      <Link
        key="#"
        to="/ordenes"
        id="ordenes"
        className="text-dark d-block w-100 mt-3 underline-decoration"
      >
        {" "}
        Ver Mis Ordenes
      </Link>
      {user.isAdmin ? (
        <Link
          type="submit"
          id="signin-button"
          className="text-dark d-block w-100 mt-3 underline-decoration"
          to="/admin"
          style={{ fontWeight: "800" }}
        >
          Admin Access
        </Link>
      ) : (
        ""
      )}
      <li
        type="submit"
        id="signin-button"
        className="text-dark d-block w-100 mt-3 pointer underline-decoration"
        onClick={removeUser}
      >
        Salir
      </li>
    </>
  );
}

export default UserMenu;
